import axios from 'axios';
import getToken from './getToken';

const hostMap = {
  // develop: 'https://app.readonup.com',
  develop: 'https://readon-api.readon.me',
  staging: 'https://readon-api-staging.readon.me',
  prod: 'https://readon-api.readon.me',
};

export const request = axios.create({
  baseURL: hostMap[process.env.VUE_APP_ENV] || hostMap.prod,
});
const handle = (res) => {
  if (res.status === 200) {
    return Promise.resolve(res.data);
  } else {
    return Promise.reject(res);
  }
};
export const get = async (url, params, useToken = false, config) => {
  let headers = {};
  if (useToken) {
    const token = await getToken();
    headers = {
      authorization: token,
    };
  }
  return request({
    method: 'get',
    url,
    params,
    headers,
    ...config,
  }).then(handle);
};
export const post = async (url, data, useToken = false, config) => {
  let headers = {};
  if (useToken) {
    const token = await getToken();
    headers = {
      authorization: token,
    };
  }
  return request({
    method: 'post',
    url,
    data,
    headers,
    ...config,
  }).then(handle);
};
